var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('video',{attrs:{"src":require("./assets/FantasyGrowTentSeason2.mp4"),"type":"video/mp4","width":"550","controls":"","autoplay":""}}),_c('HelloWorld',{attrs:{"msg":"Fantasy Grow Tent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }